export interface HolidayFormData {
	id: number;
	description: string;
	date: string;
	recurring: boolean;
	states: string[];
	clinicIds: number[];
}

export const emptyFormData: HolidayFormData = {
	id: 0,
	description: "",
	date: "",
	recurring: false,
	states: [],
	clinicIds: []
};
